import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取2019版全国5级信息表列表 get
 * @param query 分页参数
 * @return request
 * */
export function getAreaList(query) {
    return request({
        url: `${baseURL.businessApi}/areas`,
        method: 'get',
        params: query
    })
}

/**
 * 增加2019版全国5级信息表 post
 * @param data 增加的数据
 * @return request
 * */
export function addArea(data) {
    return request({
        url: `${baseURL.businessApi}/areas`,
        method: 'post',
        data: data
    })
}

/**
 * 删除2019版全国5级信息表  delete
 * @param id 2019版全国5级信息表id
 * @return request
 * */
export function deleteArea(id) {
    return request({
        url: `${baseURL.businessApi}/areas/${id}`,
        method: 'delete'
    })
}

/***
 * 修改2019版全国5级信息表 Post
 * @param id 要修改的2019版全国5级信息表id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateArea(id, data) {
    return request({
        url: `${baseURL.businessApi}/areas/${id}`,
        method: 'post',
        data: data
    })
}

/**
 * 查看区域树
 * @returns {AxiosPromise}
 */
export function getTreeArea() {
    return request({
        url: `${baseURL.businessApi}/areas/tree`,
        method: 'get',
    })
}

export function getCourtTreeArea() {
    return request({
        url: `${baseURL.businessApi}/areas/tree/byType?enumType=COURT`,
        method: 'get',
    })
}

/**
 * 获取值
 * @param id
 * @returns {AxiosPromise}
 */
export function getTreeAreaValue(id) {
    return request({
        url: `${baseURL.businessApi}/areas/treeValue`,
        method: 'get',
        params: {areaId: id}
    })
}
